module.exports = __webpack_public_path__ + "img/logo.90e38ca8.png";